export default __webpack_public_path__ + "static/media/aispeak_section.682feb1a.png";